<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import WarOrder from "@/components/WarOrder";
export default {
  name: 'App',
  components: {
    WarOrder
  }
}
</script>

<style>
body {
  background-color: #f1f4fa;
  margin: 0;
  padding: 0;
  font-family: -apple-system-font, Helvetica Neue, Helvetica, sans-serif;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[v-cloak] {
  display: none;
}
</style>
